import type { ICellRendererParams } from "ag-grid-community";
import { IconArrowDownChevronSmall, IconArrowRight } from "@synthesis/shared-icons";

import type { ServiceProcessVersion } from "../service-detail-page.lib";

/** Ячейка-стрелка раскрытия строки версии: разворачивает/сворачивает detail-панель (master/detail AG Grid). */
export const VersionExpandCell = (params: ICellRendererParams<ServiceProcessVersion>) => {
  const { node, api } = params;

  if (!node) {
    return null;
  }

  const expanded = Boolean(node.expanded);

  return (
    <button
      type="button"
      aria-label={expanded ? "Свернуть стадии версии" : "Развернуть стадии версии"}
      aria-expanded={expanded}
      className="text-neutrals-60 hover:text-type-common hover:bg-neutrals-95/80 inline-flex size-8 items-center justify-center rounded-lg transition-colors"
      onClick={(event) => {
        event.stopPropagation();
        node.setExpanded(!expanded);
        api.refreshCells({ rowNodes: [node], force: true });
      }}
    >
      {expanded ? <IconArrowDownChevronSmall className="size-5" /> : <IconArrowRight className="size-5" />}
    </button>
  );
};
